import { Component, Inject, OnInit, Optional } from '@angular/core';
import { Compbaser } from "../compbaser";
import { SceneAddService, StoreSelectorsService } from "../../services";
import { MatIconList } from '../../common/mat-icons';
import * as _ from 'lodash';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Memoizee } from 'app/decorators/memoizee-decorator';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-icons',
    templateUrl: './icons.component.html',
    styleUrls: ['./icons.component.scss']
})
export class IconsComponent extends Compbaser implements OnInit {
    iconList = [];

    blockSmallView: boolean;
    filter = '';
    isDialog = false;

    throttle = 300;
    scrollDistance = 2;
    initialCount = 200;
    verticalMoreCount = 50;
    
    constructor(
        private sceneAddService: SceneAddService, 
        private storeSelector: StoreSelectorsService,
        @Optional() public dialogRef?: MatDialogRef<IconsComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data?: any
    ) {
        super();
        if (dialogRef || data) {
            this.isDialog = true;
            this.initialCount = 300;
            this.verticalMoreCount = 100;
        }
            
        this.iconList = MatIconList;
        
    }

    ngOnInit() {
        this.blockSmallView = this.sceneAddService.blockSmallView;
        this.applyFilter();
    }

    applyFilter() {
        const showCount = this.blockSmallView ? (2 * this.initialCount) : this.initialCount;
        if (!this.filter || this.filter.length < 1) {
            this.iconList = MatIconList.slice(0, showCount);
            return;
        }
        this.iconList = MatIconList.filter(i => i.includes(this.filter.toLowerCase())).slice(0, showCount);
    }

    clearFilter() {
        this.filter = '';
        this.applyFilter();
    }

    /**
     * get tooltip for icon
     * @param icon
     * @returns
     */
    @Memoizee({})
    getTooltip(icon: string) {
        if (!icon) return null;
        return icon.replace(/_/g, ' ');
    }

    closeDialog() {
        if (this.dialogRef) this.dialogRef.close();
    }

    
    dropIcon(event: CdkDragDrop<any>) {
        if (this.isDialog) return;
        if (event.isPointerOverContainer) return;
        if (!event.item?.data) return;

        const iconTemplate = _.cloneDeep(this.storeSelector.blockLabels.ICON.template);
        if (!iconTemplate) return;

        iconTemplate.Data[0].Icon[0].$.name = event.item.data;

        const offset = this.sceneAddService.getOffset(event);
        this.sceneAddService.addScenePlayers([iconTemplate], offset.offsetX, offset.offsetY);
    }

    selectIcon(icon: string) {
        if (this.isDialog) {
            if (this.dialogRef) this.dialogRef.close(icon);
        } else {
            const iconTemplate = _.cloneDeep(this.storeSelector.blockLabels.ICON.template);
            iconTemplate.Data[0].Icon[0].$.name = icon;
            this.sceneAddService.addScenePlayers([iconTemplate], 100, 100);
        }
    }

    /** Load more icons when scroll down */
    loadMoreIcons() {
        const cnt = this.iconList.length;
        const filtered = MatIconList.filter(i => i.includes((this.filter || "").toLowerCase()));
        if (cnt < filtered.length) {
            const moreCount = this.blockSmallView ? (2 * this.verticalMoreCount) : this.verticalMoreCount;
            this.iconList.push(...filtered.slice(cnt, cnt + moreCount));
        }
    }

    override destroy() {
        super.destroy();
    }
}
